export const ICONOCLAST_URL = 'https://shuhari-iconoclast-production.herokuapp.com';
export const ICON_TVEYES_URL = 'http://tveyecons.meltwater.net';



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/content-document-adapter.config.ts